import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

//Секция сайт
const StartPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/StartPage.vue');
// const TariffsPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/TariffsPage.vue');
// const TariffsPacketsPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/TariffsPacketsPage.vue');
// const TariffsTvPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/TariffsTvPage.vue');
// const TariffsInternetPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/TariffsInternetPage.vue');
const Business = () => import(/* webpackChunkName: "group-site" */ './../pages/site/BusinessPage.vue');
const LegalInformation = () => import(/* webpackChunkName: "group-site" */ './../pages/site/LegalInformationPage.vue');
const ContactsPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/ContactsPage.vue');
const NewsPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/NewsPage.vue');
const NewsDetailPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/NewsDetailPage.vue');
const AboutUs = () => import(/* webpackChunkName: "group-site" */ './../pages/site/AboutPage.vue');
const Restore = () => import(/* webpackChunkName: "group-site" */ '../pages/site/RestorePage.vue');
const BlockedPage = () => import(/* webpackChunkName: "group-site" */ './../pages/site/BlockedPage.vue');
const ServicesPage = () => import(/* webpackChunkName: "group-site" */'./../pages/site/ServicesPage.vue');
const OrderSignPage = () => import(/* webpackChunkName: "group-site" */'./../pages/site/OrderSignPage.vue');
const OrderSignedSuccess = () => import(/* webpackChunkName: "group-site" */'./../pages/site/OrderSignedSuccess.vue');

//Секция личный кабинет абонента
const CabinetPage = () => import(/* webpackChunkName: "group-cabinet" */ './../pages/cabinet/CabinetPage.vue');
const LoginCabinetPage = () => import(/* webpackChunkName: "group-cabinet" */ './../pages/cabinet/LoginCabinetPage.vue');
const CodeLoginPage = () => import(/* webpackChunkName: "group-cabinet" */ './../pages/cabinet/CodeLoginPage.vue');
const ChangePasswordPage = () => import(/* webpackChunkName: "group-cabinet" */ './../pages/cabinet/ChangePasswordPage.vue');

//Секция администрирования
const LoginPage = () => import(/* webpackChunkName: "group-admin" */ './../pages/admin/LoginPage.vue');
const AdminsPage = () => import(/* webpackChunkName: "group-admin" */ './../pages/admin/AdminPage.vue');
const AdminTariffsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminTariffsPage.vue');
const AdminNewsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminNewsPage.vue');
const AdminUsersPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminUsersPage.vue');
const AdminPaymentsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminPaymentsPage.vue');
const AdminStreetsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminStreetsPage.vue');
const AdminHousesPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminHousesPage.vue');
const AdminCitiesPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminCitiesPage.vue');
const AdminSlidersPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminSlidersPage.vue');
const AdminAgentsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminAgentsPage.vue');
const AdminTariffBlocksPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminTariffBlocksPage.vue');
const AdminRemoteServicePage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminRemoteServicePage.vue');
const AdminInterviewsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminInterviewsPage.vue');
const AdminRatesPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminRatesPage.vue');
const AdminAnswersPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminAnswersPage.vue');
const AdminParametersPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminParametersPage.vue');
const AdminActionsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminActionsPage.vue');
const AdminActionContractsPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminActionContractsPage.vue');
const AdminFilesPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminFilesPage.vue');
const AdminOfficesPage = () => import(/* webpackChunkName: "group-admin" */'./../pages/admin/AdminOfficesPage.vue');

//Секция оплаты
const PaymentsPage = () => import(/* webpackChunkName: "group-payments" */ './../pages/payment/PaymentsPage.vue');
const PaymentsStepperPage = () => import(/* webpackChunkName: "group-payments" */ './../pages/payment/PaymentsStepperPage.vue');
const PaymentsInformationPage = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsInformationPage.vue');
const PaymentsAgreementPage = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsAgreementPage.vue');
const PaymentsCash = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsCash.vue');
const PaymentsRefindPage = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsRefindPage.vue');
const PaymentsCheckPage = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsCheckPage.vue');
const PaymentsDisabled = () => import(/* webpackChunkName: "group-payments" */'./../pages/payment/PaymentsDisabled.vue');

//Секция помощь абонентам
const SubscribersPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersPage.vue');
const SubscribersCtvServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersCtvServicePage.vue');
const SubscribersInstallCaPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersInstallCaPage.vue');
const SubscribersFrequencyPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersFrequencyPage.vue');
const SubscribersInternetServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersInternetServicePage.vue');
const SubscribersIptvServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersIptvServicePage.vue');
const SubscribersRouterServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersRouterServicePage.vue');
const SubscribersRemoteServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersRemoteServicePage.vue');
const SubscribersCamServicePage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersCamServicePage.vue');
const SubscribersDevicesPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersDevicesPage.vue');
const SubscribersInstructionsPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersInstructionsPage.vue');
const SubscribersCentraDomPage = () => import(/* webpackChunkName: "group-subscribers" */ './../pages/subscriber/SubscribersCentraDomPage.vue');

//Секция с акциями
const ActionPage = () => import(/* webpackChunkName: "group-actions" */ './../pages/actions/CottonCandyPage.vue');
const IviResultPage = () => import(/* webpackChunkName: "group-actions" */ './../pages/actions/IviResultPage.vue');
const EmailCheckBegin = () => import('./../pages/actions/EmailCheckBegin.vue');
const EmailCheckEnd = () => import('./../pages/actions/EmailCheckEnd.vue');
const EmailCheckFail = () => import('./../pages/actions/EmailCheckFail.vue');

export default new Router({
    routes: [
        {
            path: '/',
            component: StartPage,
            meta: { title: 'Лайка - главная' },
        },
        {
            path: '/admins',
            component: AdminsPage,
            children: [
                {
                    path: '/admins/tariffs',
                    component: AdminTariffsPage,
                },
                {
                    path: '/admins/users',
                    component: AdminUsersPage,
                },
                {
                    path: '/admins/news',
                    component: AdminNewsPage,
                },
                {
                    path: '/admins/payments',
                    component: AdminPaymentsPage,
                },
                {
                    path: '/admins/streets',
                    component: AdminStreetsPage,
                },
                {
                    path: '/admins/houses',
                    component: AdminHousesPage,
                },
                {
                    path: '/admins/cities',
                    component: AdminCitiesPage,
                },
                {
                    path: '/admins/sliders',
                    component: AdminSlidersPage,
                },
                {
                    path: '/admins/agents',
                    component: AdminAgentsPage,
                },
                {
                    path: '/admins/tariff-blocks',
                    component: AdminTariffBlocksPage,
                },
                {
                    path: '/admins/remote-service',
                    component: AdminRemoteServicePage,
                },
                {
                    path: '/admins/interviews',
                    component: AdminInterviewsPage,
                },
                {
                    path: '/admins/rates',
                    component: AdminRatesPage,
                },
                {
                    path: '/admins/answers',
                    component: AdminAnswersPage,
                },
                {
                    path: '/admins/parameters',
                    component: AdminParametersPage,
                },
                {
                    path: '/admins/actions',
                    component: AdminActionsPage,
                },
                {
                    path: '/admins/action-contracts',
                    component: AdminActionContractsPage,
                },
                {
                    path: '/admins/files',
                    component: AdminFilesPage,
                },
                {
                    path: '/admins/offices',
                    component: AdminOfficesPage,
                },
            ]
        },
        {
            path: '/admins/login',
            component: LoginPage,
        },
        // {
        //     path: '/tariffs',
        //     component: TariffsPage,
        //     children: [
        //         {
        //             path: '/tariffs/packets',
        //             component: TariffsPacketsPage,
        //             meta: { type: 'tariffs', title: 'Лайка - тарифы' },
        //         },
        //         {
        //             path: '/tariffs/tv',
        //             component: TariffsTvPage,
        //             meta: { type: 'tariffs', title: 'Лайка - тарифы' },
        //         },
        //         {
        //             path: '/tariffs/internet',
        //             component: TariffsInternetPage,
        //             meta: { type: 'tariffs', title: 'Лайка - тарифы' },
        //         },
        //     ]
        // },
        {
            name: 'payments',
            path: '/payments',
            component: PaymentsPage,
            children: [
                {
                    name: 'Поиск договора',
                    path: '/payments/stepper',
                    //redirect: '/payments/disabled',
                    component: PaymentsStepperPage,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: true },
                },
                {
                    name: 'Описание оплаты',
                    path: '/payments/information',
                    component: PaymentsInformationPage,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: true },
                },
                {
                    name: 'Соглашение',
                    path: '/payments/agreement',
                    component: PaymentsAgreementPage,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: true },
                },
                {
                    name: 'Возврат оплаты',
                    path: '/payments/refind',
                    component: PaymentsRefindPage,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: true },
                },
                {
                    name: 'Оплата наличными',
                    path: '/payments/cash',
                    component: PaymentsCash,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: true },
                },
                {
                    name: 'Оплата услуг',
                    path: '/payments/check',
                    component: PaymentsCheckPage,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: false },
                },
                {
                    name: 'Уважаемые абоненты!',
                    path: '/payments/disabled',
                    component: PaymentsDisabled,
                    meta: { type: 'payments', title: 'Лайка - оплата', visible: false },
                }
            ]
        },
        {
            path: '/cabinet',
            component: CabinetPage,
            meta: { type: 'cabinet', title: 'Лайка - личный кабинет' },
        },
        {
            path: '/cabinet/login',
            component: LoginCabinetPage,
            meta: { type: 'cabinet', title: 'Лайка - вход в личный кабинет' },
        },
        {
            path: '/cabinet/code',
            component: CodeLoginPage,
            meta: { type: 'cabinet', title: 'Лайка - вход в личный кабинет' },
        },
        {
            path: '/cabinet/change-password',
            component: ChangePasswordPage,
            meta: { type: 'cabinet', title: 'Лайка - изменение пароля' },
        },
        {
            path: '/about',
            component: AboutUs,
            meta: { title: 'Лайка - компания' },
        },
        {
            path: '/business',
            component: Business,
            meta: { title: 'Лайка - для бизнеса' },
        },
        {
            path: '/news',
            component: NewsPage,
            meta: { title: 'Лайка - новости' },
        },
        {
            path: '/news/:id',
            component: NewsDetailPage,
            meta: { title: 'Лайка - новости' },
        },
        {
            path: '/legal',
            component: LegalInformation,
            meta: { title: 'Лайка - информация' },
        },
        {
            path: '/contacts',
            component: ContactsPage,
            meta: { title: 'Лайка - контакты' },
        },
        {
            path: '/order/:taskId',
            component: OrderSignPage,
            meta: { title: 'Centra - подписание заказа' },
        },
        {
            path: '/order/signed/success',
            component: OrderSignedSuccess,
            meta: { title: 'Centra - заказ подписан' },
        },
        {
            path: '/restore',
            component: Restore,
            meta: { title: 'Centra - восстановление услуги' },
        },
        {
            path: '/blocked',
            component: BlockedPage,
            meta: { title: 'Лайка' },
        },
        {
            path: '/services',
            component: ServicesPage,
            meta: { type: 'services', title: 'Лайка - услуги' },
        },
        {
            name: 'subscribers',
            path: '/subscribers',
            component: SubscribersPage,
            meta: { title: 'Лайка - помощь' },
            children: [
                // {
                //     name: 'Оборудование',
                //     path: '/subscribers/devices',
                //     component: SubscribersDevicesPage,
                //     meta: { title: 'Лайка - помощь', visible: true },
                // },
                {
                    name: 'Видеонаблюдение',
                    path: '/subscribers/cam-service',
                    component: SubscribersCamServicePage,
                    meta: { title: 'Лайка - помощь', visible: true },
                },
                {
                    name: 'Настройка IPTV',
                    path: '/subscribers/iptv-service',
                    component: SubscribersIptvServicePage,
                    meta: { title: 'Лайка - помощь', visible: false },
                },
                {
                    name: 'Настройка цифрового ТВ',
                    path: '/subscribers/ctv-service',
                    component: SubscribersCtvServicePage,
                    meta: { title: 'Лайка - помощь', visible: true },
                },
                {
                    name: 'Частоты каналов',
                    path: '/subscribers/frequency',
                    component: SubscribersFrequencyPage,
                    meta: { title: 'Лайка - помощь', visible: false },
                },
                {
                    name: 'Установка СА-модуля',
                    path: '/subscribers/install-ca',
                    component: SubscribersInstallCaPage,
                    meta: { title: 'Лайка - помощь', visible: true },
                },
                {
                    name: 'Настройка интернета',
                    path: '/subscribers/internet-service',
                    component: SubscribersInternetServicePage,
                    meta: { title: 'Лайка - помощь', visible: false },
                },
                {
                    name: 'Настройка роутера',
                    path: '/subscribers/router-service',
                    component: SubscribersRouterServicePage,
                    meta: { title: 'Лайка - помощь', visible: false },
                },
                {
                    name: 'Удаленный помощник',
                    path: '/subscribers/remote-service',
                    component: SubscribersRemoteServicePage,
                    meta: { title: 'Лайка - помощь', visible: false },
                },
                {
                    name: 'Centra Дом',
                    path: '/subscribers/centra-dom',
                    component: SubscribersCentraDomPage,
                    meta: { title: 'Лайка - помощь', visible: true },
                },
            ]
        },
        {
            name: 'ivi_result',
            path: '/ivi/result',
            component: IviResultPage,
            meta: { title: 'Лайка - IVI Авторизация' },
        },
        {
            name: 'email_check_success',
            path: '/email/check/success',
            component: EmailCheckEnd,
            meta: { title: 'Лайка - Подтверждение e-mail' }
        },
        {
            name: 'email_check_fail',
            path: '/email/check/fail',
            component: EmailCheckFail,
            meta: { title: 'Лайка - Подтверждение e-mail' }
        },
        {
            name: 'email_check_begin',
            path: '/email/check/:token',
            component: EmailCheckBegin,
            meta: { title: 'Лайка - Подтверждение e-mail' }
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js